/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCalculateBillingCharges.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/calculate-billing-charges";

export class AutogenModelCalculateBillingCharges<RowType extends ModelRow> extends Endpoint<RowType, RowCalculateBillingChargesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCalculateBillingCharges extends ModelRow<RowCalculateBillingChargesFields> {
	constructor(values?: Partial<RowCalculateBillingChargesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCalculateBillingChargesFields {
	agent: string;
	autorate_status: string;
	bill_date: Date;
	bill_type: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_row: string;
	billing_user_id: string;
	blnum: string;
	booking_number: string;
	broker: string;
	commodity: string;
	commodity_descr: string;
	company_id: string;
	consignee_ref_no: string;
	container: string;
	customer_id: string;
	delivery_date: Date;
	dist_include_split: string;
	distance: number;
	distance_um: string;
	driver_id: string;
	edi_transfered: string;
	entered_user_id: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	external_invoiceno: string;
	factoring_exp_date: Date;
	factoring_id: string;
	fixed_charge_label: string;
	fixed_charge_seg_alloc_code: string;
	hold_reason_code: string;
	hold_reason_text: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	invoice_no: number;
	invoice_no_string: string;
	invoice_recv_date: Date;
	invoiced_flag: string;
	is_dedicated_bill: string;
	is_fixed: string;
	is_intercompany: string;
	is_split_bill: string;
	linehaul_chg: number;
	linehaul_chg_c: string;
	linehaul_chg_d: Date;
	linehaul_chg_n: number;
	linehaul_chg_r: number;
	lock_miles: string;
	master_order_id: string;
	max_target_pay_data: string;
	message: string;
	minimum_weight: number;
	minimum_weight_um: string;
	order_id: string;
	order_type_id: string;
	other_charge: number;
	other_charge_c: string;
	other_charge_d: Date;
	other_charge_n: number;
	other_charge_r: number;
	other_charges: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	payment_method: string;
	pieces: number;
	port: string;
	post_key: string;
	post_module: string;
	printed: string;
	purchase_order_no: string;
	rate: number;
	rate_id: number;
	rate_type: string;
	rate_unit_desc: string;
	rating_method: string;
	rating_units: number;
	ready_to_process: string;
	rebilled: string;
	revenue_id: string;
	round_trip_flag: string;
	ship_date: Date;
	shipment_id: string;
	stop_data: string;
	total_charges: number;
	total_charges_c: string;
	total_charges_d: Date;
	total_charges_n: number;
	total_charges_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_id: string;
	trailer2_id: string;
	trailer_id: string;
	transfer_date: Date;
	vessel: string;
	weight: number;
	weight_um: string;
	autorate: boolean;
	billing_row: string;
	calculate_max_target: boolean;
	estimate_fsc: boolean;
}

